import { FieldType } from 'common/fields/entities/enums'
import { Field } from 'common/fields/entities/field'
import { DATE_FORMULA, DATE_TIME_FORMULA } from 'common/filter/models/AudienceFilter/constants'

export const exportFormula = (target: { value: number; field: Field }) => {
  const type = target?.field?.type ?? null
  const value = target?.value ?? null

  if (value) {
    let formula = ''

    switch (type) {
      case FieldType.DATETIME:
        formula = DATE_TIME_FORMULA
        break
      case FieldType.DATE:
        formula = DATE_FORMULA
        break
      default:
        formula = ''
        break
    }

    return `${formula}({{cuf_${value}}})`
  }

  return undefined
}
